import React from 'react'
import { Card } from '@foodsby/nutrient-v3'
import { Article } from '../common/Layout'

export const JoinPage = () => {
  return (
    <Article>
      <div className="row center-xs">
        <div className="col-xs-12">
          <Card>
            The referrals program has ended. Please visit{' '}
            <a href="https://www.foodsby.com">our homepage</a> to log in or
            create an account.
          </Card>
        </div>
      </div>
    </Article>
  )
}

export default JoinPage
